module.exports = __webpack_public_path__ + "img/0Q3B3793_L_Black.be74a086.jpg";